module.exports = __webpack_public_path__ + "img/mg-all.74741193.png";